import React from 'react';
import SEOHead from '../SEOHead';
import { PreloadedSpotifyEmbed } from '../PreloadedEmbeds';

const ReleasesPage = () => {
  const spotifyTracks = [
    { id: '0rt1nQOw34V0SXRAw5oOuD', name: 'Ghost In Plain Sight' },
    { id: '4Fujv6FSCx3EzSLyYO3zlz', name: 'Venomous Crusade' },
    { id: '4E83tT4l2rlPLID47YpwVy', name: 'From The Inside' },
    { id: '15TLRRojTlqRKI3aT8MV0b', name: 'Masked Reality' },
    { id: '6ydc7efV09laNTLfuzVDPb', name: "Autumn's Embrace" },
    { id: '2H2FKAtMcmfufnWgeYMg02', name: 'Screen-Lit Youth' },
    { id: '6cExbnvow5Vsw8M5Wg3atS', name: 'OK Boomer (Screen-Lit Youth Response)' }
  ];

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "MusicAlbum",
    "name": "Exlo Latest Releases",
    "byArtist": {
      "@type": "MusicGroup",
      "name": "Exlo",
      "url": "https://music.exlo.no"
    },
    "genre": ["Electronic", "AI-Assisted Music", "Digital Music"],
    "url": "https://music.exlo.no/releases",
    "description": "Stream Exlo's latest electronic tracks on Spotify. Featuring Ghost In Plain Sight, Venomous Crusade, From The Inside, Masked Reality, Autumn's Embrace, Screen-Lit Youth, and OK Boomer.",
    "track": [
      {
        "@type": "MusicRecording",
        "name": "Ghost In Plain Sight",
        "url": "https://open.spotify.com/track/0rt1nQOw34V0SXRAw5oOuD"
      },
      {
        "@type": "MusicRecording", 
        "name": "Venomous Crusade",
        "url": "https://open.spotify.com/track/4Fujv6FSCx3EzSLyYO3zlz"
      },
      {
        "@type": "MusicRecording",
        "name": "From The Inside",
        "url": "https://open.spotify.com/track/4E83tT4l2rlPLID47YpwVy"
      }
    ]
  };

  return (
    <div className="min-h-screen bg-[#1a1a2e] text-white">
      <SEOHead
        title="Exlo Latest Music Releases - Electronic Songs with Emotional Depth"
        description="Stream Exlo's latest electronic tracks on Spotify. Featuring Ghost In Plain Sight, Venomous Crusade, From The Inside, Masked Reality, Autumn's Embrace, Screen-Lit Youth, and OK Boomer."
        url="/releases"
        type="music.album"
        structuredData={structuredData}
      />
      
      <noscript>
        <div className="p-8 text-center">
          <h1 className="text-3xl font-bold mb-4 text-[#e94560]">Exlo Latest Releases</h1>
          <p className="text-lg mb-4">Stream Exlo's latest electronic tracks on Spotify:</p>
          <ul className="list-disc list-inside space-y-2">
            <li>Ghost In Plain Sight - Listen on <a href="https://open.spotify.com/track/0rt1nQOw34V0SXRAw5oOuD" className="text-cyan-400 underline">Spotify</a></li>
            <li>Venomous Crusade - Listen on <a href="https://open.spotify.com/track/4Fujv6FSCx3EzSLyYO3zlz" className="text-cyan-400 underline">Spotify</a></li>
            <li>From The Inside - Listen on <a href="https://open.spotify.com/track/4E83tT4l2rlPLID47YpwVy" className="text-cyan-400 underline">Spotify</a></li>
          </ul>
        </div>
      </noscript>

      <div className="p-4 md:p-8 max-w-6xl mx-auto">
        <header className="mb-8">
          <h1 className="text-4xl font-bold mb-4 text-[#e94560]">Latest Releases</h1>
          <p className="text-lg text-gray-300">Stream Exlo's latest electronic tracks on Spotify. Each song explores themes of resilience, hope, and human emotion through digital sound.</p>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {spotifyTracks.map((track) => (
            <PreloadedSpotifyEmbed key={track.id} trackId={track.id} trackName={track.name} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReleasesPage;
